import Head from "next/head";
import { useEffect } from "react";
import { Box } from "@mui/material";

import { MemoizedFooter } from "../src/layouts/footer";
import { MemoizedHeader } from "../src/layouts/header";
import CustomerStorySwiper from "../src/modules/Common/CustomerStorySwiper";
import StoryDrawer from "../src/modules/Finance/storyDrawer";
import CarouselDrawer from "../src/modules/Home/Drawer/carouselDrawer";
import BenefitSection from "../src/modules/Store/benefitSection";
import BrandBanner from "../src/modules/Store/brandBanner";
import BrandLocation from "../src/modules/Store/brandLocation";
import BrandVehicleList from "../src/modules/Store/brandVehicleList";
import StoreForm from "../src/modules/Store/storeForm";
import Breadcrumbs from "../src/components/common/Breadcrumbs";
import { sendAnalytics } from "../src/utils/analyticsCommon";

export default function LatestStories() {
  const BREADCRUMB_ITEMS = [
    { label: "Home", href: "/" },
    { label: "Brand Store" },
  ];

  const BREADCRUMB_SCHEMA = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://www.turno.club/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Brand Store",
        item: "https://www.turno.club/brand-store",
      },
    ],
  };

  useEffect(() => {
    sendAnalytics(
      "screen_viewed",
      { screen_name: "multi-brand-store-page" },
      "en"
    );
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Head>
        <title>Multi Brand Store</title>
        <meta name="description" />
        <meta
          name="keywords"
          content="Turno, Multi Brand Store,  Electric Three Wheeler, electric commercial vehicle price, 3 wheeler loading auto, electric goods vehicle, 3 wheeler, mahindra ev, piaggio price, etrio, osm"
        />
        <meta name="author" content="Turno" />
        <meta name="url" content="https://www.turno.club/brand-store" />

        <meta name="robots" content="noindex, nofollow" />
        <meta name="lang" content="en" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://www.turno.club/brand-store" />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(BREADCRUMB_SCHEMA),
          }}
          defer
        />
      </Head>

      {/* <BookVehicleDrawer /> */}
      <CarouselDrawer />
      <MemoizedHeader />

      <BrandBanner />
      <BrandLocation />
      <BenefitSection />

      <BrandVehicleList />

      <StoreForm />

      <CustomerStorySwiper />

      <StoryDrawer />
      <Box sx={{ width: { xs: "100%", md: "84%" }, margin: "20px auto", padding: { xs: "0 12px", md: "0" } }}>
        <Breadcrumbs items={BREADCRUMB_ITEMS} />
      </Box>
      <MemoizedFooter />
    </>
  );
}
